"use client";

/**
 * CollabV3Analytics 컴포넌트
 * @description 상세 진입 계측 — 화면에는 아무것도 그리지 않는다. 예전 2.0 웹 상세와 같은
 *   `Collab Viewed`(유입 `ref` · UTM 포함)를 한 번만 쏜다. 리렌더마다 쏘면 체류가 긴 사람이 여러 명으로
 *   잡힌다. SDK 초기화도 여기서 한다.
 * @example <CollabV3Analytics subject={subject} isGuest={detail.isGuest} />
 */
import { memo, useEffect, useRef } from "react";

import type { CollabV3AnalyticsProps } from "./CollabV3Detail.types";

import { trackCollabV3Viewed } from "../../analytics";
import { initAmplitude } from "@/shared/lib/analytics/amplitude";

const CollabV3Analytics = memo<CollabV3AnalyticsProps>(
  ({ subject, isGuest }) => {
    const hasTracked = useRef(false);

    useEffect(() => {
      if (hasTracked.current) return;
      hasTracked.current = true;
      initAmplitude();
      trackCollabV3Viewed(subject, isGuest);
    }, [subject, isGuest]);

    return null;
  },
);

CollabV3Analytics.displayName = "CollabV3Analytics";

export default CollabV3Analytics;
